module.exports = __webpack_public_path__ + "static/img/icon-six-step-1.ddca3ba1.png";